var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ng-tns-c4279958036-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -960 960 960","aria-hidden":"true","focusable":"false"}},[_c('path',{staticClass:"ng-tns-c4279958036-2",attrs:{"d":"M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }